import { createSelector } from '@reduxjs/toolkit'
import { StoreState } from '@/ducks/store/slice/store.slice'

export const selectStore = (state: { store: StoreState }) => state.store

export const selectStoreId = createSelector(selectStore, state => state.id)
export const selectUsername = createSelector(
  selectStore,
  state => state.username
)
export const selectStoreType = createSelector(selectStore, state => state.type) 
export const selectStoreAvatar = createSelector(
  selectStore,
  state => state.avatar
)
export const selectStoreStatus = createSelector(
  selectStore,
  state => state.loginDeniedStatus
)
export const selectStoreCashCoStatus = createSelector(
  selectStore,
  state => state.usingCashCo
)
export const selectStoreAvailability = createSelector(
  selectStore,
  state => state.availability
)
export const selectStoreName = createSelector(
  selectStore,
  state => state.storeName
)
export const selectCurrencyCode = createSelector(
  selectStore,
  state => state.currencyCode
)
export const selectCurrencySymbol = createSelector(
  selectStore,
  state => state.currencySymbol
)
export const selectPhoneNumber = createSelector(
  selectStore,
  state => state.phoneNumber
)
export const selectPhoneCode = createSelector(
  selectStore,
  state => state.phoneCode
)
export const selectFullPhone = createSelector(
  [selectPhoneCode, selectPhoneNumber],
  (phoneCode, phoneNumber) => `${phoneCode}${phoneNumber}`
)
export const selectSelectedBranchId = createSelector(
  (state: { store: StoreState }) => state.store,
  (storeState: StoreState) => storeState.selectedBranchId
)
export const selectIsPostRejection = createSelector(
  selectStore,
  state => state.isPostRejection
)
